function getFormattedDate() {
  const date = new Date();
  return date.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
}

// 下载文件
export async function downloadFile(result: Response, fileName: string, isShowTime = false) {
  const blob = await result.blob();
  const downloadLink = document.createElement("a");
  downloadLink.href = URL.createObjectURL(blob);
  downloadLink.download =
    fileName + (isShowTime ? ` ${getFormattedDate().split(",").join("")}` : "") + ".xlsx";
  downloadLink.click();
}

// Pack type
export enum PackingType {
  BAG = 1,
  BUBBLE_WRAP = 2,
  RIGID_CONTAINER = 3,
  NO_OUTER_PACKAGING = 4,
  OTHER = 5,
}
export const PackTypeMap = {
  [PackingType.BAG]: "Bag",
  [PackingType.RIGID_CONTAINER]: "Rigid container",
  [PackingType.NO_OUTER_PACKAGING]: "No outer packaging, item is bare",
  [PackingType.BUBBLE_WRAP]: "Bubble wrap",
  [PackingType.OTHER]: "Other",
};
export interface IPackingType {
  title: string;
  desc?: string;
  value: PackingType;
}
export const PackTypeList: IPackingType[] = [
  {
    title: "Bag",
    desc: "for example, polybag, foil-lined bag, and so on",
    value: PackingType.BAG,
  },
  {
    title: "Rigid container",
    desc: "for example, plastic or cardboard box, plastic bottle",
    value: PackingType.RIGID_CONTAINER,
  },
  {
    title: "No outer packaging, item is bare",
    desc: "for example, uncovered toy mounted to cardboard",
    value: PackingType.NO_OUTER_PACKAGING,
  },
  {
    title: "Bubble wrap",
    value: PackingType.BUBBLE_WRAP,
  },
  {
    title: "Other",
    value: PackingType.OTHER,
  },
];

// Product type
export enum ProductType {
  MOST = 1,
  APPAREL = 2,
  DANGEROUS = 3,
}
export const ProductTypeMap = {
  [ProductType.MOST]: "Most",
  [ProductType.APPAREL]: "Apparel",
  [ProductType.DANGEROUS]: "Dangerous",
};

// Discrepancy Type
export enum DiscrepancyType {
  OVER_CHARGED = 1,
  UNDER_CHARGED = 2,
  CORRECTLY_CHARGED = 3,
  INCALCULABLE = 4,
}
export const DiscrepancyTypeMap = {
  [DiscrepancyType.OVER_CHARGED]: "OVER CHARGED",
  [DiscrepancyType.UNDER_CHARGED]: "UNDER CHARGED",
  [DiscrepancyType.CORRECTLY_CHARGED]: "CORRECTLY CHARGED",
  [DiscrepancyType.INCALCULABLE]: "INCALCULABLE",
};

export const formatDateToCustomString = (date: Date, defaultFormat = true): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return defaultFormat
    ? `${year}-${month}-${day}T${hours}-${minutes}-${seconds}`
    : `${day}/${month}/${year} ${hours}:${minutes}`;
};

export const formatUTCtoLocal = (utcTimeStr: string, isTableShow = false): string => {
  // 匹配 MM/DD/YYYY HH:mm 格式
  const match = utcTimeStr.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/);
  if (!match) return utcTimeStr;

  // 解析输入时间组件
  const [, inputMonth, inputDay, inputYear, inputHours, inputMinutes] = match;

  // 构造 UTC 时间对象
  const utcDate = new Date(
    isTableShow
      ? `${inputDay}/${inputMonth}/${inputYear} ${inputHours}:${inputMinutes}`
      : `${inputYear}-${inputMonth}-${inputDay}T${inputHours}:${inputMinutes}:00Z`,
  );
  if (isNaN(utcDate.getTime())) return utcTimeStr;

  // 复用通用格式化方法
  return formatDateToCustomString(utcDate, false);
};

export const transformFilename = (filename: string): string => {
  // 匹配 "前缀-时间戳.扩展名" 结构
  const pattern = /^(.*?-)(\d{10,})(\..+)$/;
  const match = filename.match(pattern);
  if (!match) return `${filename.split(".xlsx")[0]}_${formatDateToCustomString(new Date())}`;

  // 提取时间戳并转换
  const [, prefix, timestamp, extension] = match;
  const date = new Date(Number(timestamp));
  if (isNaN(date.getTime()))
    return `${filename.split(".xlsx")[0]}_${formatDateToCustomString(new Date())}`;

  // 复用通用格式化方法
  const formattedDate = formatDateToCustomString(date);

  return `${prefix.endsWith("-") ? prefix.split("-").slice(0, -1).join("-") : prefix}_${formattedDate}`;
};
